import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Calendar, Video } from "lucide-react";

export function UpcomingWebinars() {
  const [items, setItems] = useState([]);
  const [zoom, setZoom] = useState("");

  useEffect(() => {
    api.get("/oral-champion/me").then((r) => {
      const now = Date.now();
      const upcoming = (r.data.applications || [])
        .filter((a) => a.status === "confirmed" && !a.certificate_id && a.session_at && new Date(a.session_at).getTime() > now)
        .sort((a, b) => new Date(a.session_at) - new Date(b.session_at));
      setItems(upcoming);
    }).catch(() => {});
    api.get("/oral-champion/webinar").then((r) => setZoom(r.data.zoom_link || "")).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <div data-testid="upcoming-webinars" className="bg-brand rounded-2xl p-5 md:p-6 mb-6 text-white">
      <div className="flex items-center gap-2 mb-4">
        <Calendar className="h-5 w-5 text-coral" />
        <h3 className="font-heading font-bold">Upcoming Oral Champion webinars</h3>
      </div>
      <div className="space-y-3">
        {items.map((a, i) => (
          <div key={a.id} data-testid={`webinar-${i}`} className="flex flex-wrap items-center justify-between gap-3 bg-white/10 rounded-xl px-4 py-3">
            <div>
              <div className="font-semibold">{a.registrant_name}</div>
              <div className="text-sm text-white/70">{a.session_date || "Date to be confirmed"}</div>
            </div>
            {zoom && (
              <a href={zoom} target="_blank" rel="noreferrer">
                <Button data-testid={`webinar-join-${i}`} size="sm" className="rounded-full bg-coral hover:bg-coral-hover text-white h-9">
                  <Video className="h-4 w-4 mr-2" />Join Zoom
                </Button>
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
